import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import vms from "../../Assets/Projects/vms.png";
import interviewBuddyImg from "../../Assets/Projects/ib.png";
import guidana from "../../Assets/Projects/Guidana.png";
import novaCrm from "../../Assets/Projects/NOVA.png";
import bnbpulse from "../../Assets/Projects/BNB.png";
import growthware from "../../Assets/Projects/growthware.png";
// import tradingBot from "../../Assets/Projects/frow.png";
// import pureh2o from "../../Assets/Projects/pureh2o.png";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {/* Guidana.com - LinkedIn-like Social App */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={guidana}
              isBlog={false}
              title="Guidana.com"
              description="LinkedIn-like social application with real-time chat using Socket.io, FCM notifications, job posting, course posting, friend connections, post sharing, streams, and comments. Built with React.js, Redux Toolkit, and modern web technologies for seamless social networking experience."
              demoLink="http://guidana.com/"
            />
          </Col>

          {/* Nova CRM - Visa Management System */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={novaCrm}
              isBlog={false}
              title="Nova CRM"
              description="Comprehensive Visa Management CRM with multi-role support (Admin, Agent, Client). Built using React.js, Redux Toolkit, Express.js, and PostgreSQL. Features include visa application tracking, document management, role-based access control, and automated workflow processes."
              demoLink="https://nova-crm-2u80.onrender.com/"
            />
          </Col>

          {/* BNBPulse - Property Management */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bnbpulse}
              isBlog={false}
              title="BNBPulse"
              description="Next.js + MongoDB property management system for hotels and hostels with role-based authentication. Features include booking management, room inventory, guest management, payment processing, and comprehensive analytics dashboard for property owners."
              demoLink="https://bnbpulse-webapp-dev.onrender.com/"
            />
          </Col>

          {/* Growthware.com */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={growthware}
              isBlog={false}
              title="Growthware.com"
              description="React.js application with Contentful CMS for a gamified business growth platform. Provides essential tools to build powerful funnels that drive leads to loyal customers. Focuses on growth strategies to identify business opportunities and stay ahead of competitors."
              demoLink="https://growthware.com/"
            />
          </Col>

          {/* Trading Bot
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={frow}
              isBlog={false}
              title="Trading Bot"
              description="React + Flask application with SQLite3 for stock trading data visualization. Features real-time market data, trading analytics, portfolio management, and interactive charts using Recharts for comprehensive trading insights and decision-making support."
              demoLink="https://trading-bot-lac.vercel.app/"
            />
          </Col> */}

          {/* AI Buddy - Interview Practice Platform */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={interviewBuddyImg}
              isBlog={false}
              title="AI Buddy (Interview Buddy)"
              description="React + Flask platform for online interview practice with analytics. Product-based mock interview platform using Next.js (frontend) and Python Flask (backend) with SQLite3 for automated evaluation, personalized feedback, and comprehensive analytics to enhance interview readiness."
              demoLink="https://ai-buddy-phi.vercel.app/"
            />
          </Col>

          {/* Vendor Management System (VMS) */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vms}
              isBlog={false}
              title="Vendor Management System (VMS)"
              description="Comprehensive desktop application built using Electron.js, React.js, and Express.js with SQLite3 database. Streamlines company operations including vendor relations, budgeting, finance history, inventory management, and provides an efficient solution for businesses of all sizes."
              ghLink=""
              demoLink="https://drive.google.com/file/d/1RWVusacm45xnmzkFRUwjYqPG7d2S21Gp/view?usp=sharing"
            />
          </Col>

          {/* Pure H2O - FYP */}
          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pureh2o}
              isBlog={false}
              title="Pure H2O (Final Year Project)"
              description="Innovative B2B E-commerce platform for water product companies. Provides a dynamic marketplace for showcasing and selling water products with seamless seller-buyer interactions. Features include seller onboarding, product catalog management, order processing, and comprehensive buyer experience."
              demoLink="https://pure-h2o.vercel.app/"
            />
          </Col> */}

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
